/* NDI globe.gl activity globe — arcs + points are built into globe.gl (three.js based),
   so projection is correct out of the box (no hand-rolled math). Heavy dep (~1.75MB,
   ndi-globegl.min.js bundles three.js). Routes from data-ndi-routes JSON.
   Globe is exposed as a UMD global `Globe` by the bundle. */
(function () {
  function mount(root) {
    if (typeof Globe === 'undefined') return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var routes;
    try { routes = JSON.parse(root.dataset.ndiRoutes); } catch (e) { return; }
    if (!routes || !routes.origin || !(routes.destinations || []).length) return;

    var el = root.querySelector('.ndi-globegl__stage');
    if (!el) return;

    var origin = routes.origin;
    var dests = routes.destinations;
    var ORIGIN_LABEL = 'NJ Network Devices';

    // one arc per destination — but the tour shows only the active one at a time.
    var allArcs = dests.map(function (d) {
      return {
        startLat: origin.lat, startLng: origin.lng,
        endLat: d.lat, endLng: d.lng, name: d.name,
      };
    });

    // Origin dot is always shown; the active destination dot is added during the tour.
    var originPoint = { lat: origin.lat, lng: origin.lng, size: 0.6, color: '#008ed6' };

    // City name labels (HTML): origin persistent, active destination toggled.
    function labelEl(text, color) {
      // globe.gl overwrites the wrapper's own transform each frame to center it (0.5,0.5)
      // on the dot — so we can't anchor via the wrapper's transform. Instead the wrapper is a
      // zero-size point AT the dot, and the chip+stem are absolutely positioned so the STEM'S
      // BASE lands on that point (pole rises up from the dot, chip clears the marker).
      var wrap = document.createElement('div');
      wrap.className = 'ndi-globegl__pin';
      wrap.style.cssText = 'position:relative;width:0;height:0;pointer-events:none;';
      var stack = document.createElement('div');
      // bottom edge sits on the dot (bottom:0), horizontally centered (left:0 + translateX -50%)
      stack.style.cssText = 'position:absolute;left:0;bottom:0;transform:translateX(-50%);'
        + 'display:flex;flex-direction:column;align-items:center;';
      var chip = document.createElement('div');
      chip.textContent = text;
      chip.style.cssText = 'color:#fff;font:600 12px/1.2 system-ui,sans-serif;white-space:nowrap;'
        + 'padding:3px 9px;border-radius:999px;background:' + color + ';'
        + 'box-shadow:0 2px 10px rgba(0,0,0,.5);';
      var stem = document.createElement('div');
      stem.style.cssText = 'width:2px;height:22px;background:' + color + ';opacity:.75;';
      stack.appendChild(chip);
      stack.appendChild(stem);
      wrap.appendChild(stack);
      return wrap;
    }

    var g = Globe()(el)
      .backgroundColor('rgba(0,0,0,0)')
      .showAtmosphere(true)
      .atmosphereColor('#25a9ef')      // brighter blue glow
      .atmosphereAltitude(0.28)        // larger halo
      .showGlobe(true)
      // dotted earth: transparent sphere, continents drawn as a hex-dot grid
      .hexPolygonResolution(3)
      .hexPolygonMargin(0.62)
      .hexPolygonUseDots(true)
      .hexPolygonColor(function () { return 'rgba(0,142,214,1)'; })
      .arcsData([])                    // tour fills in the single active arc
      .arcColor(function () { return ['rgba(0,142,214,0.2)', 'rgba(0,142,214,1)']; })
      .arcStroke(0.6)
      .arcDashLength(1)                // one dash spans the whole line...
      .arcDashGap(1)                   // ...with an equal gap, so initialGap reveals it
      .arcDashInitialGap(1)            // start fully hidden; rAF drives this 1→0 to "draw" it
      .arcDashAnimateTime(0)           // 0 = no built-in loop → no phantom; we animate the gap
      .arcsTransitionDuration(0)
      .pointsData([originPoint])
      .pointColor('color')
      .pointAltitude(0.01)
      .pointRadius(function (p) { return p.size * 1.6; })
      .pointsMerge(false)              // false so the active dest dot can be added/removed
      // expanding pulse rings — "signal broadcasting"; origin always pulses.
      .ringsData([{ lat: origin.lat, lng: origin.lng, rgb: '0,142,214' }])
      .ringColor(function (r) {
        return function (t) { return 'rgba(' + r.rgb + ',' + (1 - t) + ')'; };
      })
      .ringMaxRadius(8)                // travel further out
      .ringPropagationSpeed(2)
      .ringRepeatPeriod(1100)
      // HTML city-name pins; origin label is always present.
      .htmlElementsData([{ lat: origin.lat, lng: origin.lng, txt: ORIGIN_LABEL, col: '#008ed6' }])
      .htmlElement(function (d) { return labelEl(d.txt, d.col); })
      .htmlAltitude(0.01);            // anchor ON the dot; the stem lifts the chip above it

    // Solid dark sphere (NDI navy) with the dotted continents rendered on top.
    var mat = g.globeMaterial();
    if (mat && mat.color && mat.color.set) {
      mat.color.set('#202434');        // --ndi-color-secondary
      if (mat.emissive && mat.emissive.set) mat.emissive.set('#11131c');
      if ('shininess' in mat) mat.shininess = 5;
      mat.needsUpdate = true;
    }

    // Load country outlines and render them as the hex-dot grid.
    if (root.dataset.ndiCountries) {
      fetch(root.dataset.ndiCountries)
        .then(function (r) { return r.json(); })
        .then(function (geo) { g.hexPolygonsData((geo.features) || []); })
        .catch(function () {}); // dots optional — arcs/points still render if fetch fails
    }

    // Render the canvas larger than its slot so the atmosphere glow has pixels to live in
    // (it clips at the WebGL canvas edge otherwise). Negative margin re-centers the overscan;
    // the camera is pulled in by the same factor (below) so the globe stays the same visual size.
    var OVERSCAN = 1.35;
    function size() {
      var slot = el.clientWidth;
      var w = Math.round(slot * OVERSCAN);
      g.width(w).height(w);
      // Offset globe.gl's ROOT element (holds BOTH the canvas and the html-pin overlay) so
      // they move together — margining just the canvas left the pins in the unshifted overlay.
      var rootEl = el.firstElementChild;
      if (rootEl) {
        var off = -(w - slot) / 2 + 'px';
        rootEl.style.position = 'relative';
        rootEl.style.left = off;
        rootEl.style.top = off;
      }
    }
    size();
    window.addEventListener('resize', size);
    g.controls().autoRotate = false;   // tour drives the camera instead
    g.controls().enableZoom = false;

    // --- Tour: sit on NJ → arc out to a customer → glide back to NJ → next customer ---
    // altitude scaled so the globe fills the same visual size despite the oversized canvas
    var BASE_ALT = 1.8 * 1.35;         // OVERSCAN — keep in sync with size()
    var HOME = { lat: origin.lat, lng: origin.lng, altitude: BASE_ALT };
    var FLY = 1600;        // camera glide ms (match arc draw)
    var HOLD_DEST = 1800;  // pause on the customer
    var HOLD_HOME = 900;   // pause back at base before next arc
    var idx = 0;

    g.pointOfView(HOME, 0); // start centered on base

    // Move the camera ALONG the great-circle arc (not a straight cut) by slerping
    // between the two lat/lngs on the unit sphere and re-centering each frame.
    var DEG = Math.PI / 180, RAD = 180 / Math.PI;
    function toVec(lat, lng) {
      var la = lat * DEG, lo = lng * DEG;
      var ca = Math.cos(la);
      return [ca * Math.cos(lo), ca * Math.sin(lo), Math.sin(la)];
    }
    function vecToLatLng(v) {
      return { lat: Math.asin(v[2]) * RAD, lng: Math.atan2(v[1], v[0]) * RAD };
    }
    // Pause state: gates the rAF flight, the step timers, and globe.gl's own render loop.
    var paused = false;
    var pausedAt = 0;                  // timestamp when a flight was frozen, to shift its clock
    var timers = [];                   // pending pause-aware timeouts (cleared/rescheduled on pause)
    function wait(ms, fn) {            // setTimeout that won't fire while paused
      var rec = { fn: fn, remaining: ms, at: Date.now(), id: 0 };
      rec.id = setTimeout(function () {
        var i = timers.indexOf(rec);  // self-remove so it isn't re-fired on the next resume
        if (i > -1) timers.splice(i, 1);
        fn();
      }, ms);
      timers.push(rec);
      return rec;
    }

    var rafId = 0;
    function flyAlong(fromLat, fromLng, toLat, toLng, ms, done, onProgress) {
      var a = toVec(fromLat, fromLng), b = toVec(toLat, toLng);
      var dot = Math.max(-1, Math.min(1, a[0] * b[0] + a[1] * b[1] + a[2] * b[2]));
      var omega = Math.acos(dot), sinO = Math.sin(omega);
      var start = null, prevLng = fromLng, lastTs = 0;
      cancelAnimationFrame(rafId);
      function frame(ts) {
        // while paused, keep re-queuing without advancing: push `start` forward by the gap
        if (paused) { lastTs = ts; rafId = requestAnimationFrame(frame); return; }
        if (start === null) start = ts;
        if (lastTs && ts - lastTs > 40) start += (ts - lastTs); // resumed: absorb the paused gap
        lastTs = ts;
        var t = Math.min(1, (ts - start) / ms);
        var e = t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2; // easeInOutQuad
        if (onProgress) onProgress(e);
        var v;
        if (sinO < 1e-4) { v = a; }
        else {
          var w1 = Math.sin((1 - e) * omega) / sinO, w2 = Math.sin(e * omega) / sinO;
          v = [a[0] * w1 + b[0] * w2, a[1] * w1 + b[1] * w2, a[2] * w1 + b[2] * w2];
        }
        var ll = vecToLatLng(v);
        // unwrap longitude: never let it jump ±360 across the antimeridian (kills the "random spin")
        while (ll.lng - prevLng > 180) ll.lng -= 360;
        while (ll.lng - prevLng < -180) ll.lng += 360;
        prevLng = ll.lng;
        // pull the camera back at mid-flight so the whole arc reads, tighten in on arrival
        var alt = BASE_ALT + 0.9 * Math.sin(Math.PI * e);
        g.pointOfView({ lat: ll.lat, lng: ll.lng, altitude: alt }); // no duration → instant, no fighting tween
        if (t < 1) rafId = requestAnimationFrame(frame);
        else if (done) done();
      }
      rafId = requestAnimationFrame(frame);
    }

    function labelData(withDest) {
      var arr = [{ lat: origin.lat, lng: origin.lng, txt: ORIGIN_LABEL, col: '#008ed6' }];
      if (withDest) arr.push({ lat: withDest.endLat, lng: withDest.endLng, txt: withDest.name, col: '#f9aa01' });
      return arr;
    }

    function step() {
      var arc = allArcs[idx];
      // destination dot + ring + label appear UP FRONT so the arc draws toward a visible target
      g.arcsData([arc]);
      g.arcDashInitialGap(1);          // reset: line starts fully hidden
      g.pointsData([originPoint, { lat: arc.endLat, lng: arc.endLng, size: 0.35, color: '#f9aa01' }]);
      g.ringsData([
        { lat: origin.lat, lng: origin.lng, rgb: '0,142,214' },
        { lat: arc.endLat, lng: arc.endLng, rgb: '249,170,1' },
      ]);
      g.htmlElementsData(labelData(arc));

      // outbound: camera rides the great circle while the arc DRAWS from NJ to the city.
      // arcDashInitialGap 1→0 grows the line in lockstep with the camera (e is eased 0→1).
      flyAlong(origin.lat, origin.lng, arc.endLat, arc.endLng, FLY, function () {
        g.arcDashInitialGap(0);        // line fully drawn on arrival
        wait(HOLD_DEST, function () {
          // return: clear extras, then follow the same great circle back to NJ
          g.arcsData([]);
          g.pointsData([originPoint]);
          g.ringsData([{ lat: origin.lat, lng: origin.lng, rgb: '0,142,214' }]);
          g.htmlElementsData(labelData(null));
          flyAlong(arc.endLat, arc.endLng, origin.lat, origin.lng, FLY, function () {
            idx = (idx + 1) % allArcs.length;
            wait(HOLD_HOME, step);
          });
        });
      }, function (e) {
        g.arcDashInitialGap(1 - e);    // draw the line outward in sync with the camera
      });
    }
    // --- Pause/resume: freezes flight (rAF gate), step timers, and globe.gl's render loop ---
    function setPaused(p) {
      if (p === paused) return;
      paused = p;
      if (p) {
        g.pauseAnimation();            // stop globe.gl redrawing rings/globe → drops idle CPU
        timers.forEach(function (r) {  // freeze pending step timers, remember what's left
          clearTimeout(r.id);
          r.remaining = Math.max(0, r.remaining - (Date.now() - r.at));
        });
      } else {
        g.resumeAnimation();
        var pending = timers.splice(0); // reschedule with the time that was left
        pending.forEach(function (r) { wait(r.remaining, r.fn); });
      }
    }

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'ndi-globegl__pause';
    btn.setAttribute('aria-label', 'Pause animation');
    btn.textContent = '❚❚';
    btn.addEventListener('click', function () {
      var next = !paused;
      setPaused(next);
      btn.textContent = next ? '▶' : '❚❚';
      btn.setAttribute('aria-label', next ? 'Play animation' : 'Pause animation');
    });
    root.appendChild(btn);

    wait(600, step); // small beat after mount before the first arc
  }

  // Lazy: only mount a globe whose container is visible (tab shown). One-shot per element.
  function mountVisible() {
    document.querySelectorAll('[data-ndi-globegl]').forEach(function (root) {
      if (root.dataset.ndiMounted) return;
      if (root.offsetParent === null) return; // hidden tab → skip
      root.dataset.ndiMounted = '1';
      mount(root);
    });
  }
  if (document.readyState !== 'loading') mountVisible();
  else document.addEventListener('DOMContentLoaded', mountVisible);
  document.addEventListener('ndi:globe-show', mountVisible); // tab reveal triggers init
})();
